import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { getSessionQueryOptions } from '@/lib/session'
import { commonSearchSchema } from '@/lib/utils'

// Sign-in, registration, and recovery pages allow signed-out users and anonymous guests.
export const Route = createFileRoute('/_signedOut')({
  component: Outlet,
  validateSearch: commonSearchSchema,
  beforeLoad: async ({ context, search }) => {
    const { data } = await context.queryClient.fetchQuery(getSessionQueryOptions())

    // Saving guest progress needs the guest's browser session; without it, sign-in would save nothing.
    if (search.upgradeId && !data?.user?.isAnonymous) {
      throw redirect({ to: '/upgrade-failed' })
    }

    if (data?.user && !data.user.isAnonymous) {
      throw redirect({ to: '/account' })
    }
  },
})
